import React from 'react';
import { useState, useEffect } from 'react'; 
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import CreateTicket from './createSupportEmail/CreateTicket';
import SupportTicketsList from './history/SupportTicketsList';
import BackButton from './navigation/BackButton';

const Container: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const navigate = useNavigate(); 

  const colors = useAppSelector(state => state.theme.colors);
  const section = useAppSelector(state => state.navigation.section);
  const isMobile = useMediaQuery('(max-width:600px)');
  const sidebarWidth = `max(${isMobile ? 70 : 125}px, 5vw)`;

  return (

    <Box component="main" sx={{ 
        position: 'absolute',
        top: '5vh', // Below NavBar
        left: sidebarWidth, // Right of Sidebar
        height: 'calc(100vh - 5vh)',
        width: `calc(100vw - ${sidebarWidth})`,
        backgroundColor: colors?.interface,
        color: colors?.highlightedText,
        overflow: 'hidden', // Let children handle scrolling
        boxSizing: 'border-box',
      }}>
      
      { section === 'createTicket' && <CreateTicket />}
      { section === 'history' && <SupportTicketsList />}

    </Box>

  );

};

export default Container;